<script setup lang="ts">
import BaseHeader from "./BaseHeader.vue";
import BaseSide from "./BaseSide.vue";
</script>
<template>
  <div class="tw-flex tw-items-stretch relative tw-w-[100%]">
    <div class="tw-top-[0px] fixed tw-inset-0 w-max">
      <BaseSide/>
    </div>
    <div
      class="tw-flex tw-flex-col main-container tw-w-[100%] tw-overflow-x-hidden tw-ms-[262px]"
    >
      <BaseHeader class="tw-sticky tw-top-0 tw-z-[10]" />
      <div
        class="tw-pr-4 tw-w-full tw-py-[19px] min-h-[calc(100vh-56px)] tw-overflow-x-hidden tw-pl-[16px] 2xl:tw-pl-[24px] tw-z-10"
      >
        <router-view v-slot="{ Component }">
          <transition name="slide-fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>
<style>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(10px);
}
.slide-fade-enter-to,
.slide-fade-leave-from {
  transform: translateX(0);
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-from {
  transform: translateX(0);
}
.slide-fade-leave-to {
  transform: translateX(-10px);
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from {
  transform: translateX(-10px);
}
.slide-fade-enter-to {
  transform: translateX(0);
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-from {
  transform: translateX(0);
}
.slide-fade-leave-to {
  transform: translateX(10px);
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from {
  transform: translateX(10px);
}
.slide-fade-enter-to {
  transform: translateX(0);
}
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

</style>
